export const normalizeFields = (data) => {
  if (!Array.isArray(data))
    throw new Error('The form fields response must be a list.');
  return data.map((field) => {
    const Id = field.Id ?? field.id ?? field.ID;
    if (Id == null) throw new Error('A form field is missing its ID.');
    return {
      Id,
      FieldName: String(field.FieldName ?? field.fieldName ?? ''),
      FieldDescription: String(
        field.FieldDescription ?? field.fieldDescription ?? '',
      ),
      FormName: String(field.FormName ?? field.formName ?? ''),
      SortOrder: Number(field.SortOrder ?? field.sortOrder ?? 0),
      FormId: field.FormId ?? field.formId ?? null,
      FieldType: field.FieldType ?? field.fieldType ?? null,
    };
  });
};

export const fieldsForForm = (fields, name) =>
  fields
    .filter((field) => field.FormName === name)
    .sort(
      (a, b) =>
        a.SortOrder - b.SortOrder ||
        String(a.Id).localeCompare(String(b.Id), undefined, { numeric: true }),
    );

export const moveField = (fields, from, to) => {
  const next = [...fields];
  const [field] = next.splice(from, 1);
  next.splice(to, 0, field);
  return next;
};

export const fieldPayload = (field) => ({
  ...(field.Id != null ? { Id: field.Id } : {}),
  FieldName: field.FieldName.trim(),
  FieldDescription: field.FieldDescription.trim(),
  FormName: field.FormName.trim(),
  SortOrder: field.SortOrder,
  ...(field.FormId !== undefined ? { FormId: field.FormId } : {}),
  ...(field.FieldType !== undefined ? { FieldType: field.FieldType } : {}),
});

export const FIELD_TYPES = [
  ['text', 'Text'],
  ['textarea', 'Long text'],
  ['number', 'Number'],
  ['date', 'Date'],
  ['checkbox', 'Checkbox'],
  ['boolean', 'Boolean'],
  ['yesna', 'Yes / N/A'],
  ['yesno', 'Yes / No'],
];

export function normalizeParents(data) {
  if (!Array.isArray(data))
    throw new Error('The form parents response must be a list.');
  return data.map((parent) => {
    const Id = parent.Id ?? parent.id ?? parent.ID;
    if (Id == null) throw new Error('A form parent is missing its ID.');
    return { Id, FormName: String(parent.FormName ?? parent.formName ?? '') };
  });
}

export const belongsToForm = (field, parent) =>
  parent.Id != null
    ? field.FormId != null
      ? String(field.FormId) === String(parent.Id)
      : field.FormName === parent.FormName
    : field.FormId == null && field.FormName === parent.FormName;

export function listManagedForms(parents, fields) {
  const result = parents.map((parent) => ({
    ...parent,
    key: String(parent.Id),
  }));
  fields.forEach((field) => {
    if (!result.some((parent) => belongsToForm(field, parent))) {
      result.push({
        Id: field.FormId,
        FormName: field.FormName,
        key:
          field.FormId != null
            ? String(field.FormId)
            : `legacy:${field.FormName}`,
        orphan: true,
      });
    }
  });
  return result.sort((a, b) => {
    const leftId = a.Id == null ? Infinity : Number(a.Id);
    const rightId = b.Id == null ? Infinity : Number(b.Id);
    return leftId - rightId || a.FormName.localeCompare(b.FormName);
  });
}
